import { isEmpty } from 'lodash';
import browserUtils from './browserUtils';
import { CourseInfo, User } from '../types/userType';

const saveUser = (user: User): void => {
  if (browserUtils.isBrowser()) {
    window.localStorage.setItem('user', JSON.stringify(user));
  }
};

const deleteUser = (): void => {
  if (browserUtils.isBrowser()) {
    window.localStorage.removeItem('user');
  }
};

const getUser = (): User | null => {
  if (browserUtils.isBrowser()) {
    const user = window.localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
  return null;
};

const getCurrentCourseInfo = (
  user: User,
  selectedAY?: string
): CourseInfo | undefined => {
  if (!user.courseInfo) return undefined;

  if (selectedAY) {
    const [selectedStartYear, selectedEndYear] = selectedAY
      .split('-')
      .map(Number);

    return user.courseInfo.find(({ academicYear: { from, to } }) => {
      const fromDate = from instanceof Date ? from : new Date(from);
      const toDate = to instanceof Date ? to : new Date(to);

      const fromYear = fromDate.getFullYear();
      const toYear = toDate.getFullYear();

      return fromYear === selectedStartYear && toYear === selectedEndYear;
    });
  }

  const currentDate = new Date();
  return user.courseInfo.find(({ academicYear: { from, to } }) => {
    return currentDate >= new Date(from) && currentDate <= new Date(to);
  });
};

const getCurrentAcademicYear = (
  user: User,
  currentCourseInfo?: CourseInfo
): string | undefined => {
  let courseInfo = currentCourseInfo;
  if (isEmpty(courseInfo)) {
    courseInfo = getCurrentCourseInfo(user);
  }
  if (!courseInfo) return undefined;
  return `${new Date(courseInfo.academicYear.from).getFullYear()}-${new Date(
    courseInfo.academicYear.to
  ).getFullYear()}`;
};

const extractGradeAndDivision = (value: string): string[] => {
  let grade;
  let division;
  if (value.endsWith('-INCOMING')) {
    return [value, ''];
  }
  const lastSpaceIndex = value.lastIndexOf(' ');
  if (lastSpaceIndex === -1) {
    [grade, division] = [value, ''];
  } else {
    [grade, division] = [
      value.substring(0, lastSpaceIndex),
      value.substring(lastSpaceIndex + 1)
    ];
  }
  return [grade, division];
};

const getStudentClass = (currentCourseInfo?: CourseInfo) =>
  `${currentCourseInfo?.grade}${
    !isEmpty(currentCourseInfo?.division) ? currentCourseInfo?.division : ''
  }`;

const userUtils = {
  saveUser,
  getUser,
  deleteUser,
  getCurrentCourseInfo,
  extractGradeAndDivision,
  getCurrentAcademicYear,
  getStudentClass
};

export default userUtils;
